const FRANCHISES_TABLE_LIMIT = 12;

export {FRANCHISES_TABLE_LIMIT};
